<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-message-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-message-form" @submit.prevent="onSubmit">
        <div class="new-message-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-message-toolbar-title"
              >Create new message definition</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- message -->
          <v-container class="new-message-card-container">
            <v-row>
              <v-col sm="12">
                <dialog-input
                  label="Message"
                  name="message"
                  :textarea="true"
                  :textareaExpandable="true"
                  :value="newMessageData.message"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="12">
                <time-picker
                  :key="newMessageData.time"
                  :initial-time="newMessageData.time"
                  :is-submit="messageScheduled"
                  @input="onInput"
                />
                <!-- <dialog-time-picker
                  label="Time"
                  name="time"
                  :key="newMessageData.time"
                  :value="newMessageData.time"
                  :initial-time="newMessageData.time"
                  @input="onInput"
                /> -->
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="6">
                <dialog-date-picker
                  label="From"
                  name="from"
                  :value="newMessageData.from"
                  :initial-date="newMessageData.from"
                  @input="onInput"
                />
              </v-col>
              <v-col sm="6">
                <dialog-date-picker
                  label="To"
                  name="to"
                  :key="toKey"
                  :value="newMessageData.to"
                  :initial-date="newMessageData.to"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="12">
                <thumbnail-picker
                  label="Thumbnail"
                  :current-file="currentFile"
                  @thumbnail-picked="setThumbnail"
                  :allowed-file-types="[17, 18, 19, 20, 21, 22, 23, 52]"
                  one-source-only
                  enable-mobile-static-media
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="12">
                <dialog-checkbox
                  label="Is this message definition related to target date?"
                  name="isProcedureDateRelated"
                  :value="newMessageData.isProcedureDateRelated"
                  :option="{
                    label: 'Yes',
                    value: newMessageData.isProcedureDateRelated,
                  }"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0 d-none">
            <v-row>
              <v-col sm="12">
                <dialog-checkbox
                  label="Choose days on which messages will be sent:"
                  name="daysOfWeek"
                  :value="newMessageData.daysOfWeek"
                  :options="[
                    {
                      label: 'Monday',
                      value: newMessageData.daysOfWeek.monday,
                    },
                    {
                      label: 'Tuesday',
                      value: newMessageData.daysOfWeek.tuesday,
                    },
                    {
                      label: 'Wednesday',
                      value: newMessageData.daysOfWeek.wednesday,
                    },
                    {
                      label: 'Thursday',
                      value: newMessageData.daysOfWeek.thursday,
                    },
                    {
                      label: 'Friday',
                      value: newMessageData.daysOfWeek.friday,
                    },
                    {
                      label: 'Saturday',
                      value: newMessageData.daysOfWeek.saturday,
                    },
                    {
                      label: 'Sunday',
                      value: newMessageData.daysOfWeek.sunday,
                    },
                  ]"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-footer d-flex justify-end">
            <v-btn
              :disabled="!formIsValidCheck"
              rounded
              color="primary"
              type="submit"
              elevation="0"
            >
              Add
            </v-btn>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogInput from '@/components/forms/DialogInput.vue'
import DialogCheckbox from '@/components/forms/DialogCheckbox.vue'
// import DialogTimePicker from '@/components/forms/DialogTimePicker.vue'
import DialogDatePicker from '@/components/forms/DialogDatePicker.vue'
import TimePicker from '@/components/forms/TimePicker.vue'
import ThumbnailPicker from '@/components/inputs/ThumbnailPicker.vue'
import StaticMediaMixin from '@/mixins/staticMedia'

const emptyForm = {
  message: null,
  time: null,
  from: null,
  to: null,
  daysOfWeek: {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
  },
  isProcedureDateRelated: false,
  resourceId: null,
  staticMediaId: null,
}

export default {
  name: 'NewMessageDialog',
  mixins: [StaticMediaMixin],
  components: {
    DialogInput,
    DialogCheckbox,
    // DialogTimePicker,
    DialogDatePicker,
    TimePicker,
    ThumbnailPicker,
  },
  props: {
    participantId: {
      type: Array,
      default: () => [],
    },
    participantTz: {
      type: String,
      default: 'Europe/Warsaw',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      rules: {
        text: [v => !!v || 'Value cannot by empty'],
      },
      messageDefinition: {
        from: this.$moment().format('YYYY-MM-DD'),
        to: this.$moment().format('YYYY-MM-DD'),
        time: '06:00',
      },
      messageDefinitionDefaults: {
        from: this.$moment().format('YYYY-MM-DD'),
        to: this.$moment().format('YYYY-MM-DD'),
        time: '06:00',
      },
      formIsValidCheck: false,
      toKey: 0,
      messageScheduled: false,
      thumbnailUrl: null,
      mediaUrl: null,
      thumbnailValue: null,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      } else {
        this.dialog = false
      }
    },
    newMessageData: function(val) {
      this.formIsValid()
    },
  },
  computed: {
    newMessageData() {
      return Object.assign({}, emptyForm, this.messageDefinition)
    },
    currentFile() {
      if (!this.thumbnailUrl) {
        return null
      }
      return {
        thumbnailUrl: this.thumbnailUrl,
        mediaUrl: this.mediaUrl || null,
      }
    },
  },
  methods: {
    setThumbnail(thumbnail = null) {
      if (thumbnail === null) {
        // remove
        this.thumbnailValue = { remove: true }
      } else {
        const { type, file } = thumbnail

        if (type === 'media-library') {
          this.thumbnailValue = { mlSourceResourceId: file.id }
        } else if (type === 'file-picker') {
          this.thumbnailUrl = null
          this.mediaUrl = null
          this.thumbnailValue = file
        } else if (type === 'mobile-static-media') {
          this.thumbnailUrl = null
          this.mediaUrl = null
          this.thumbnailValue = { staticMediaId: file.id }
        }
      }
    },
    formIsValid() {
      if (
        this.newMessageData.message &&
        this.newMessageData.message.trim() !== '' &&
        this.newMessageData.time &&
        this.newMessageData.to &&
        this.newMessageData.from &&
        this.$moment(this.newMessageData.from) <=
          this.$moment(this.newMessageData.to) &&
        this.$moment(
          this.newMessageData.from + ' ' + this.newMessageData.time,
        ).diff(this.$moment(this.getParticipantTime()).format(), 'HH') > 0
      )
        this.formIsValidCheck = true
      else this.formIsValidCheck = false
    },
    getParticipantTime() {
      const currentTime = new Date().getTime()
      const currentDateFormat = this.$moment(currentTime).format(
        'YYYY-MM-DD HH:mm:ss',
      )
      const patientDateFormat = this.$moment(currentTime)
        .tz(this.participantTz)
        .format('YYYY-MM-DD HH:mm:ss')
      const calculateDiff = this.$moment(patientDateFormat).diff(
        this.$moment(currentDateFormat),
      )

      return new Date(currentTime + calculateDiff).getTime()
    },
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    onInput({ name, value }) {
      if (name == 'from' || name == 'to') {
        this.newMessageData[name] = this.$moment(value).format('YYYY-MM-DD')
        if (name == 'from') {
          if (
            this.$moment(this.newMessageData['to']).isBefore(
              this.newMessageData['from'],
              'day',
            )
          ) {
            this.newMessageData['to'] = this.newMessageData['from']
            this.toKey++
          }
        }
      } else if (name == 'daysOfWeek') {
        let tmp = {}
        value.forEach(el => {
          tmp[el.toLowerCase()] = true
        })
        this.newMessageData[name] = tmp
      } else {
        if (Array.isArray(value)) {
          this.newMessageData[name] = value[0]
        } else {
          this.newMessageData[name] = value ? value : '' // we don't want null here
        }
      }
      this.$emit('on-change', { ...this.newMessageData })
      this.formIsValid()
    },
    onSubmit() {
      this.messageScheduled = true
      this.$emit('on-submit', {
        ...this.newMessageData,
        thumbnailValue:
          this.thumbnailValue?.staticMediaId ||
          this.thumbnailValue?.mlSourceResourceId ||
          this.thumbnailValue?.remove
            ? { ...this.thumbnailValue }
            : this.thumbnailValue,
      })
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.new-message {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
    background: $bh-blue--4 !important;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-gray--2;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-file-button {
    margin-right: 10px;
    .v-icon {
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
}
</style>
